import { useState, useRef } from 'react';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import formlabels from './data/formlabels.json'
import { Form, Field } from 'react-final-form';
import type { BuslineData } from "./classes/datatypes";
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { classNames } from 'primereact/utils';
import { TabView, TabPanel } from 'primereact/tabview';
import { InputSwitch } from 'primereact/inputswitch';
import ReCAPTCHA from "react-google-recaptcha";
import fetchDataSync from './api/fetch';
import BuslineItem from './classes/buslineitem.class';
import renderFamilyMemberForm from './front modules/renderFamilyMemberForm';
import type { participantData } from './classes/participantData';
import { calculateAge } from './utils/calculateAge';

let busLines = [];
let chapitres = [];

const data = fetchDataSync();
if (data) {
  busLines = data.buslines;
  chapitres = data.chapitres;
}

const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
const getFormErrorMessage = (meta) => {
  return isFormFieldValid(meta) ? <small className="p-error">{meta.error}</small> : <small>&nbsp;</small>;
};
function getPrices(bld: BuslineData, birthDate: string): { priceOneWay: number; priceRoundTrip: number; priceNoTrip: number } {
  if (!bld || !bld.priceRules || !birthDate) {
    console.log("getPrices: missing data", bld, birthDate);
    return {
      "priceOneWay": 1e5,
      "priceRoundTrip": 1e5,
      "priceNoTrip": 1e5
    };
  }
  const person_age = calculateAge(birthDate);
  const ages = bld.priceRules.map(price => price.ageMax);
  const selectedages = ages.filter(age => age >= person_age);
  const lowestagemax = Math.min(
    ...selectedages
  );
  return bld.priceRules.find(price => price.ageMax === lowestagemax) || {
    "priceOneWay": 1e5,
    "priceRoundTrip": 1e5,
    "priceNoTrip": 1e5
  };
}
function exactPrice(member): { currency: string; price: number; memberName: string } {
  if (member.currentStep < 4) {
    return { 'currency': '€', 'price': 0, 'memberName': "???(" + (member.surname || '') + " " + (member.name || '') + ")" };
  }
  const currency = (member.takesPart || member.personID > 0) ?
    ((member.takesBus) ? member.busLine.currency : member.chapitreRegion.currency) :
    (member.address_country === "CH" ? "CHF" : "€");
  const price = (member.takesPart || member.personID > 0) ?
    (member.takesBus ?
      (new BuslineItem(member.busLine)).getPrice(member.birthDate)[(member.tripType === 'roundtrip') ? 'priceRoundTrip' : 'priceOneWay'] :
      (getPrices(member.chapitreRegion, member.birthDate).priceNoTrip)
    ) : 0;
  console.log(price);
  const memberName = member.name + " " + member.surname + "(" + (member.birthDate ? calculateAge(member.birthDate) : "") + ")";
  return { currency, price, memberName };
}
const RegisterForm = () => {
  let params = new URLSearchParams(window.location.search);
  let lang = params.get('lang');
  lang = (lang !== null && formlabels.hasOwnProperty(lang)) ? lang : 'en';
  const [formData, setFormData] = useState<participantData[]>([{ personID: 0, currentStep: 0, takesPart: true, name: '', surname: '', isSpouse: undefined }]);
  const [recaptchaValidated, setRecaptchaValidated] = useState(false);
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const [labelslanguage, _setLabelsLanguage] = useState(lang);
  const [submitted, setSubmitted] = useState(false);
  const [tabcount, setTabCount] = useState(1);
  const [activeIndex, setActiveIndex] = useState(0);
  const setLabelsLanguage = (l) => {
    if (l !== null && formlabels.hasOwnProperty(l)) {
      _setLabelsLanguage(l)
    }
  }
  const handleSubmit = async (e) => {
    if (!recaptchaToken) {
      alert("Please complete the CAPTCHA before submitting.");
      return;
    }
    const formDataWithCaptcha = {
      members: [
        ...formData.map((member) => ({
          ...member,
          busLine: member.busLine?.name,
          chapitre: member.chapitre?.name,
          chapitreRegion: member.chapitreRegion?.name,
        }))],
      recaptcha: recaptchaToken,
      maillanguage: labelslanguage
    };


    console.log("Form Data Sent:", formDataWithCaptcha);

    try {
      const response = await fetch('https://chartrespilgerverein.ch/backend/register.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formDataWithCaptcha),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (result.status === 'OK') {
        console.log('Form Data Submitted Successfully:', result);
        setSubmitted(true);
      } else {
        console.error('Error from backend:', result.message);
        alert(`Error: ${result.message}`);
      }
    } catch (error) {
      console.error('Submission error:', error);
      alert('An error occurred while submitting the form. Please try again.');
    }
  };
  const addFamilyMemberButton = useRef(null);
  return (
    <div className="container">
      {submitted ? (
        <div>
          <h3>Registration Successful!</h3>
          <p>Thank you for registering, {formData[0].name} {formData[0].surname}.</p>
        </div>
      ) : (<>
        <div className="flex justify-content-between flex-wrap">
          <Button type="button"
            icon="mr-2 pi pi-user-plus"
            ref={addFamilyMemberButton}
            severity='secondary'
            onClick={() => {
              setFormData([...formData, { personID: tabcount, currentStep: 0, name: '', surname: '', takesPart: true, isSpouse: undefined }]);
              setTabCount(t => t + 1);
            }}>
            {formlabels[labelslanguage].addFamilyMember}
          </Button>          <Dropdown
            value={labelslanguage}
            options={Object.keys(formlabels).map((lang) => ({ label: formlabels[lang].emoji + " " + lang.toUpperCase(), value: lang }))}
            onChange={(e) => setLabelsLanguage(e.value)}
          />
        </div>
        <div>
          <TabView
            activeIndex={activeIndex}
            onTabClose={(e) => {
              const updatedFormData = [...formData].filter((p, i) => i !== e.index);
              if (updatedFormData.filter((member) => member.isSpouse === false).length === 1 && !updatedFormData[0].takesPart && updatedFormData[0].currentStep === 4)
                updatedFormData[0].currentStep = 1;
              setFormData(updatedFormData);
              setActiveIndex((prevIndex) => Math.min(prevIndex, updatedFormData.length - 1));
            }}
            style={{ width: "100%" }}
            scrollable={true}
            onTabChange={(e) => setActiveIndex(e.index)}
          >
            {[...formData.map((_, index) =>
              renderFamilyMemberForm(
                {
                  sfd: (a) => {
                    const updatedFormData = [...formData]; // Create a new array
                    updatedFormData[index] = a;
                    setFormData(updatedFormData);
                  },
                  fd: formData,
                  familyMember: formData[index],
                  labelslanguage,
                  jumptolasttab: (e) => { setActiveIndex(tabcount); },
                  addFamilyMember: () => { addFamilyMemberButton.current.click() },
                  isFormFieldValid,
                  getFormErrorMessage,
                  getPrices,
                  exactPrice,
                  busLines,
                  chapitres
                })), (

              <TabPanel key={"submissionpanel"} header={formlabels[labelslanguage].submission} closable={false} leftIcon={"pi mr-2 pi-send"}>
                <Form
                  validate={(data) => {
                    if (!data.IAgree)
                      return { IAgree: formlabels[labelslanguage]['This field is required.'] };
                    return {};
                  }}
                  onSubmit={(e) => {
                    console.log(formData);
                    if (formData.some(member => member.currentStep < 4))
                      setActiveIndex(formData.findIndex(member => member.currentStep < 4));
                    else {
                      if (!recaptchaValidated)
                        alert("Please complete the CAPTCHA before submitting.");
                      else
                        handleSubmit(e);
                    }

                  }}
                  initialValues={{ IAgree: false }}
                  render={({ handleSubmit }) => {
                    return <>
                      <div className="flex align-items-center justify-content-center py-3 border-round-md mt-3 flex-column">
                        <table className="col-12 md:col-6">
                          {
                            Object.entries(formData.map(exactPrice)
                              .reduce((acc: Record<string, { sum: number; members: Array<{ n: string; p: number }> }>, { currency, price, memberName }) => {
                                if (!acc[currency]) {
                                  acc[currency] = { sum: 0, members: [] };
                                }
                                acc[currency].sum += price;
                                acc[currency].members.push({ n: memberName, p: price });
                                return acc;
                              }, {})).map(([currency, { sum, members }]) => (
                                <>
                                  {members.map(({ n, p }, i) => <tr key={i}><td>{n}</td> <td>{p}</td> </tr>)}
                                  <tr className="total"><td>Total {currency}</td><td>{sum}</td></tr>
                                </>

                              ))

                          }
                        </table>
                        <div className="flex flex-column justify-content-center align-items-start">
                          <div
                            className="p-text-center"
                            dangerouslySetInnerHTML={{ __html: formlabels[labelslanguage].cancellationPolicy }}
                          ></div>
                          <Field name={"IAgree"} type="checkbox" render={({ input, meta }) => (<>
                            <div className="field flex align-items-center flex-row justify-content-start">
                              <label className={classNames({ 'p-error': isFormFieldValid(meta) })}
                                style={{ marginBottom: 0 }}>{formlabels[labelslanguage].IAgree}&nbsp;</label>
                              <InputSwitch
                                {...input}
                                checked={input.checked}
                                className={classNames({ 'p-error': isFormFieldValid(meta) })} />
                            </div>
                            {getFormErrorMessage(meta)}
                          </>
                          )} />
                        </div>
                      </div>
                      <ReCAPTCHA
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                        sitekey="6Ldd_cQqAAAAAFiaKPLIO3tm9uQBLOFFmazVeSVi"
                        onChange={(token) => {
                          if (token) {
                            setRecaptchaToken(token);
                            setRecaptchaValidated(true);
                            console.log("Captcha validated successfully:", token);
                          } else {
                            setRecaptchaValidated(false);
                            setRecaptchaToken(null);
                            console.log("Captcha validation failed.");
                          }
                        }}
                      />
                      <div className="flex justify-content-center align-items-center mt-5">
                        <Button
                          type="submit"
                          onClick={(e) => {
                            console.log(formData)
                            e.preventDefault();
                            handleSubmit(e);
                          }}
                        >
                          {formlabels[labelslanguage].submit}
                        </Button>
                      </div>
                    </>;
                  }} />
              </TabPanel>
            )]}
          </TabView>
        </div>
      </>)}
    </div >
  );
};

export default RegisterForm;
